<template>
    <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-订单管理-添加
    -->
    <el-dialog title="子订单详情" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"
        :close-on-press-escape="false" width="50%">

        <div class="product-add pb50">
            <el-form size="small" :model="formData" ref="form" label-width="100px">
                <div class="common-form">子订单详情</div>
                <!-- 全分类选择 -->
                <!-- <el-form-item label="选择全分类" prop="name" >
          <div>{{ form.categorya.name }}</div>
      
        <el-button @click="chooseCategory" icon="el-icon-plus">选择全分类作为订单管理标题</el-button>
      </el-form-item> -->


                <el-form-item label="商品图片：" prop="model.image">
                    <div class="draggable-list">
                        <draggable class="wrapper" v-model="formData.files">
                            <transition-group>
                                <div v-for="(item, index) in formData.files" :key="item.file_path">
                                    <div class="item">
                                        <img v-img-url="item.file_path" alt="file_path" />
                                        <a href="javascript:void(0);" class="delete-btn"
                                            @click.stop="deleteImg(index)"><i class="el-icon-close"></i></a>
                                    </div>
                                </div>
                            </transition-group>
                        </draggable>
                        <div class="item img-select" @click="openProductUpload('album')">
                            <i class="el-icon-plus"></i>
                        </div>
                    </div>
                </el-form-item>
                <el-form-item label="商品尺寸(长)" prop="length"><el-input v-model="formData.length" placeholder="请输入产品长度"
                        class="max-w460"></el-input></el-form-item>
                <el-form-item label="商品尺寸(宽)" prop="width"><el-input v-model="formData.width" placeholder="请输入产品宽度"
                        class="max-w460"></el-input></el-form-item>
                <el-form-item label="商品数量" prop="num"><el-input v-model="formData.num" placeholder="请输入产品数量"
                        class="max-w460"></el-input></el-form-item>
                <el-form-item label="商品类型" prop="attr">
                    <div class="quotationItem" v-for="value,ind in attr" :key="ind">
                        <div class="qname">
                            <span style="color: red;">*</span>
                            {{value.name}}
                        </div>
                        <div class="qselect">
                            <el-select v-model="value.val" :value-key="pid" placeholder="请选择">
                                <el-option v-for="ites in value.childs" :key="ites.category_id" :label="ites.name"
                                    :value="ites.category_id">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </el-form-item>
                <!--提交-->
                <div class="common-button-wrapper">
                    <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
                    <el-button size="small" type="primary" @click="onSubmit" :loading="loading">重新提交</el-button>
                </div>
            </el-form>
            <!--商品图片组件-->
            <Upload v-if="isProductUpload" :config="{ total: 9 }" :isupload="isProductUpload"
                @returnImgs="returnProductImgsFunc">上传图片
            </Upload>
            <!-- <Categoryas :isproduct="iscategorya" :excludeIds="excludeIds" :islist="false" @closeDialog="closeDialogFunc"></Categoryas> -->
        </div>
    </el-dialog>

</template>

<script>
    import HorderApi from '@/api/horder.js';
    import HproductApi from '@/api/hproduct.js';
    import Upload from '@/components/file/Upload';
    import Categoryas from "@/components/categorya/index.vue";
    import draggable from "vuedraggable";
    import Uediter from '@/components/UE.vue';
    export default {
        components: {

            /*图片上传*/
            Upload: Upload,
            Categoryas,
            draggable,
            Uediter
        },
        data() {
            return {
                /*是否上传图片*/
                isupload: false,
                isImg: false,
                /*富文本配置*/
                ueditor: {
                    text: '',
                    config: {
                        initialFrameWidth: 400,
                        initialFrameHeight: 500
                    }
                },
                /*form表单数据*/
                form: {
                    name: '',
                    code: 'custom',
                    image: [],
                    // categorya:{},
                    sort: 50,
                    intro: "",
                    bannar: []
                },
                loading: false,
                /*验证规则*/
                dialogVisible: false,
                iscategorya: false,
                excludeIds: [],
                isProductUpload: false,
                code: "album",
                attr:[]
            };
        },
        created() {
            console.log("formData", this.formData)
            this.formData.files = []
            let obj = {}
            obj.file_path = this.formData.file
            this.formData.files.push(obj)
            this.dialogVisible = this.open_add;
            let hproduct_id = this.formData.hproduct_id
            let da = {}
            da.hproduct_id = hproduct_id
            HproductApi.detail(da).then((res) => {
                console.log("产品", res)
                if(res.code == 1){
                    this.attr = res.data.attr
                }
            })
        },
        props: ["open_add", 'formData'],
        methods: {

            chooseCategory() {
                this.iscategorya = true;
            },
            /*上传*/
            openUpload(e) {
                this.isupload = true;
            },


            /*关闭弹窗*/
            dialogFormVisible(result) {
                this.$emit("close", {
                    openDialog: false,
                    "type": ""
                });
            },
            cancelFunc() { //取消
                this.dialogFormVisible("error")
            },

            onSubmit() {
                let that = this
                let attr = []
                this.attr.forEach((v,i) => {
                    attr.push(v.val)
                })
                let data = {}
                data.horder_product_id = this.formData.horder_product_id
                data.attr = attr
                data.num = this.formData.num
                data.length = this.formData.length
                data.width = this.formData.width
                data.file = this.formData.files[0].file_path
                let p = {}
                let arr = []
                arr.push(data)
                p.params = JSON.stringify(arr)
                HorderApi.resubmit(p, true).then((res) => {
                    if (res.code == 1) {
                        that.$message({
                            message: res.msg,
                            type: 'success'
                        });
                        setTimeout(() => {
                            that.dialogFormVisible()
                        }, 1500)
                    }
                })
            },

            /*取消添加，返回任务列表*/
            cancelFunc() {
                this.$emit("close", {
                    openDialog: false,
                    "type": ""
                });
            },
            /*打开上传图片*/
            openProductUpload: function(code) {
                this.isProductUpload = true;
                this.code = code
            },

            /*上传商品图片*/
            returnProductImgsFunc(e) {
                if (this.code == 'album') {
                    if (e != null) {
                        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
                        let prevent = false;
                        console.log(typeof imgExpt);
                        e.forEach((element) => {
                            let data_array = element.file_path.split(".");
                            let ext = data_array[data_array.length - 1];
                            imgExpt.forEach((e) => {
                                if (e === ext) {
                                    prevent = true
                                    return false
                                }
                            });
                        });

                        if (!prevent) {
                            this.$message.error("图片类型有误,请选择正确的图片格式");
                            return false;
                        }

                        let imgs = e;
                        // console.log(imgs)
                        this.formData.files = imgs
                        // this.$set(this.formData, "file", imgs);
                    }
                } else {
                    if (e != null) {
                        let imgExpt = ["bmp", "jpg", "jpeg", "png", "gif"];
                        let prevent = false;
                        console.log(typeof imgExpt);
                        e.forEach((element) => {
                            let data_array = element.file_path.split(".");
                            let ext = data_array[data_array.length - 1];
                            imgExpt.forEach((e) => {
                                if (e === ext) {
                                    prevent = true
                                    return false
                                }
                            });
                        });

                        if (!prevent) {
                            this.$message.error("图片类型有误,请选择正确的图片格式");
                            return false;
                        }

                        let imgs = this.form.bannar.concat(e);
                        this.$set(this.form, "bannar", imgs);
                    }
                }

                this.isProductUpload = false;
            },

            /*删除商品图片*/
            deleteImg(index) {
                console.log(index)
                console.log(this.formData)
                this.formData.files.splice(index, 1);
            },

        }
    };
</script>

<style>
    .quotationItem {
        width: 70%;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        margin: 0 0 20px;
    }
    
    .qname{
        width: 30% !important;
    }

    .edit_container {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }

    .ql-editor {
        height: 400px;
    }


    .draggable-list {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        flex-wrap: wrap;
    }

    .draggable-list .wrapper>span {
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
    }

    .draggable-list .item {
        position: relative;
        width: 110px;
        height: 110px;
        margin-top: 10px;
        margin-right: 10px;
        border-radius: 8px;
        overflow: hidden;
        border: 1px solid #dddddd;
    }

    .draggable-list .delete-btn {
        position: absolute;
        top: 0;
        right: 0;
        width: 16px;
        height: 16px;
        background: red;
        line-height: 16px;
        font-size: 16px;
        color: #ffffff;
        display: none;
    }

    .draggable-list .item:hover .delete-btn {
        display: block;
    }

    .draggable-list .item img {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        max-height: 100%;
        max-width: 100%;
    }

    .draggable-list .img-select {
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px dashed #dddddd;
        font-size: 30px;
    }

    .draggable-list .img-select i {
        color: #409eff;
    }
</style>


// WEBPACK FOOTER //
// src/views/plus/horder/index/part/resubmit.vue